import { COLUMN_TYPE, COLUMN_OLD_VALUE, COLUMN_NEW_VALUE, COLUMN_SUB_TYPE, COLUMN_DATE_TIME, COLUMN_NAME, COLUMN_IP_ADDRESS, COLUMN_UNIQUE_IDENTIFIER, COLUMN_SLOT, COLUMN_AUDIT_ACTION_TYPE, COLUMN_DATE } from "../../constants/column-types";
import { FILTER_TYPE, FILTER_SUB_TYPE, FILTER_ACTION_TYPE, FILTER_OPERATOR, FILTER_DATE } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const AuditReportColumn : TableColumn[] = [
    {
        heading: "Operator",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        searchOnName: "userLoginId",
        lookupName: "userLogin.ulUsername",
        translationKey: "operator",
        columnId: COLUMN_NAME,
        filterId: FILTER_OPERATOR,
        settingDataName: "userLogin"
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "ipAddress",
        columnId: COLUMN_IP_ADDRESS
    }, 
    {
        heading: "Date/Time",
        accessor: "dateTimeUtc",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "dateTime",
        columnId: COLUMN_DATE_TIME
    },
    {
        heading: "Action",
        accessor: "action",
        isNumeric: false,
        id: 3,
        active: true,
        searchOnName: "auditActionType.id",
        filterKey: "auditActionTypeId",
        lookupName: "auditActionType.trnName",
        translationKey: "action",
        columnId: COLUMN_AUDIT_ACTION_TYPE,
        filterId: FILTER_ACTION_TYPE,
        settingDataName: "auditActionType"
    },
    {
        heading: "Audit Type",
        accessor: "type",
        isNumeric: false,
        id: 4,
        active: true,
        searchOnName: "auditType.id",
        filterKey: "auditTypeId",
        lookupName: "auditType.nameOriginal",
        translationKey: "auditType",
        columnId: COLUMN_TYPE,
        filterId: FILTER_TYPE,
        settingDataName: "auditType"
    },
    {
        heading: "Sub Type",
        accessor: "subType",
        isNumeric: false,
        id: 5,
        active: true,
        lookupName: "auditSubType.nameOriginal",
        searchOnName: "auditSubType.id",
        filterKey: "auditSubTypeId",
        translationKey: "auditSubType",
        columnId: COLUMN_SUB_TYPE,
        filterId: FILTER_SUB_TYPE,
        settingDataName: 'auditSubType'
    },
    {
        heading: "Old Value",
        accessor: "oldValue",
        isNumeric: true,
        id: 6,
        active: true,
        translationKey: "oldValue",
        columnId: COLUMN_OLD_VALUE
    },
    {
        heading: "New Value",
        accessor: "newValue",
        isNumeric: false,
        id: 7,
        active: true,
        translationKey: "newValue",
        columnId: COLUMN_NEW_VALUE,
    },
    {
        heading: "Date",
        accessor: "dateOnly",
        isNumeric: false,
        id: 8,
        searchOnName: "dateOnly",
        sortByName: "dateOnly",
        sortDirection: "asc",
        active: false,
        translationKey: "dateOnly",
        columnId: COLUMN_DATE,
        filterId: FILTER_DATE,
        settingDataName: "date",
        hideLookup: true,
        isFilterOnlyColumn:true
    },
];

export default AuditReportColumn;
